import { ICollapsibleFiltersConfig } from '..';
import useMedia from '../../../../../../hooks/useMedia';

interface IProps {
  children: React.ReactNode[];
  config?: ICollapsibleFiltersConfig;
}

const FilterContainer = ({ children, config }: IProps) => {
  const { leftLabelWidth, rightLabelWidth } = config || {};

  const { matches } = useMedia();
  const isMobile = matches.mobile;
  const defaultLabelColumnWidth = 'minmax(max-content, 110px)';

  const firstColumnWidth = leftLabelWidth ? leftLabelWidth : defaultLabelColumnWidth;
  const thirdColumnWidth = rightLabelWidth ? rightLabelWidth : defaultLabelColumnWidth;

  return (
    <div
      className="filters-container"
      style={{
        gridTemplateColumns: isMobile
          ? `${firstColumnWidth} minmax(0,1fr)`
          : `${firstColumnWidth} minmax(0,1fr) ${thirdColumnWidth} minmax(0,1fr)`,
      }}
    >
      {children}
    </div>
  );
};

export default FilterContainer;
